import { ButtonWidth } from '../Button'

export const getLayerHeight = (buttonWidth: ButtonWidth) => buttonWidth * 0.1
